<script>
  import Header from "components/Header.svelte";
  import Footer from "components/Footer.svelte";

  export let appLogin;
  export let appLogout;
</script>

<section class="main">
  <Header {appLogin} {appLogout} />
  <slot />
</section>
<Footer />

<style>
  .main {
    max-width: 900px;
    margin: 0 auto 6rem;
    padding: 0 1rem;
  }

  @media only screen and (min-width: 600px) {
    .main {
      padding: 0 2rem;
    }
  }
</style>
